import config from "../boot/config";
import http from "../boot/http.js";
import { DateTime } from "../utils";

const route = "Import/";

export default class {

  static importRuleSpreadsheet(file, fileName) {

    let url = `${config.uploadUrl + route}ImportRuleSpreadsheet`;

    const { name, headers } = _extractFileHeaders(fileName, file);

    return http({
        url,
        method: "POST",
        params: { fileName: name },
        data: new Blob([file]),
        headers
      },
      false,
      null,
      false)
      .then(data => data)
      .catch(error => error);

  }

}

function _extractFileHeaders(fileName, file) {
  fileName = fileName || DateTime.parse(new Date(), "hh_mm_ss_DD_MM_YYYY");

  const arr = file.name.split(".");
  const extension = "." + arr[(arr.length || 1) - 1];

  const name = fileName.endsWith(".xlsx")
    ? fileName
    : fileName + extension;

  const headers = {
    'Content-Disposition': 'attachment; filename="' + file.name + '"'
  };
  return { name, headers };
}



// WEBPACK FOOTER //
// ./src/services/import.js